type ProgressBarProps = {
  value: number;
  color?: "primary" | "accent" | "secondary" | "warning";
  size?: "sm" | "md";
  trackClass?: string;
};

const colorMap: Record<string, string> = {
  primary: "bg-primary-500",
  accent: "bg-accent-500",
  secondary: "bg-secondary-500",
  warning: "bg-amber-400",
};

export default function ProgressBar({ value, color = "primary", size = "sm", trackClass }: ProgressBarProps) {
  const pct = Math.max(0, Math.min(100, value));
  const heights = size === "md" ? "h-2.5" : "h-2";
  return (
    <div
      role="progressbar"
      aria-valuenow={pct}
      aria-valuemin={0}
      aria-valuemax={100}
      className={`w-full ${heights} rounded-full ${trackClass ?? "bg-background-200"}`}
    >
      <div
        className={`${heights} rounded-full ${colorMap[color]} transition-all`}
        style={{ width: `${pct}%` }}
      ></div>
    </div>
  );
}